var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "M13 1.425v2.538h-1.512c-.556 0-.92.115-1.11.345-.192.23-.288.574-.288 1.043v1.82h2.815l-.373 2.843H10.09v7.297H7.14v-7.297H4.69V7.171h2.45V5.074c0-1.197.336-2.117 1.006-2.777.67-.651 1.551-.986 2.662-.986.938 0 1.676.038 2.193.114Z"
})));
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZjA3OTU0NmU0OTI0OTBlN2UyZDJmYzBhNDEzMjFhOWIuc3ZnIjs=";